<div role="tablist" class="aa-dash-tabgroup">
    <ng-container *ngFor="let tab of tabs">
        <div class="aa-dash-tab" [class.disabled]="tab.disabled" [class.active]="tab.active">
            <div [style.height.px]="height" class="aa-dash-tab-title" (click)="onClickTab(tab)">
                {{tab.title}}<ng-template [ngTemplateOutlet]="tab.titleTpl?.templateRef"></ng-template>
            </div>
            <div class="aa-dash-tab-border"></div>
        </div>
    </ng-container>
</div>
<div class="aa-dash-tab-content">
    <ng-container *ngFor="let tab of tabs">
        <div role="dashtabpanel" [attr.aria-labelledby]="tab.id" id="{{tab.id}}-panel" *ngIf="tab.active"
             >
            <ng-template [ngTemplateOutlet]="tab.contentTpl?.templateRef"></ng-template>
        </div>
    </ng-container>
</div>
